module.exports = __webpack_public_path__ + "img/C08_UnitTechBladeChariotChampion_Normal_ua.7f21e6c5.webp";